import { EMLAK_BEYAN_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const emlakBeyanSorgula = (muhattapId) => {
  return getRequest({ url: EMLAK_BEYAN_SORGULA  + "?muhattapId=" + muhattapId});
};

export default emlakBeyanSorgula;